import React from 'react';
import WizardContainer from '../../components/Wizard/WizardContainer';
import { ApplicationStatus } from '../../types/wizard';
import { usePageTracking, useWizardStepTracking } from '../../hooks/useAnalytics';

interface BackgroundCheckProps {
  applicationStatus: ApplicationStatus;
}

const BackgroundCheck: React.FC<BackgroundCheckProps> = ({ applicationStatus }) => {
  usePageTracking('Background Check');
  useWizardStepTracking('background-check', 7, 7);

  return (
    <WizardContainer
      currentStepId="background-check"
      applicationStatus={applicationStatus}
    >
      <div className="max-w-2xl mx-auto">
        <div className="card p-8 text-center">
          <div className="text-6xl mb-6">🔍</div>

          <h1 className="text-3xl font-bold text-charcoal mb-4">
            Background Check in Progress
          </h1>

          <p className="text-lg text-gray-600 mb-6">
            Great news! We've initiated your background check.
          </p>

          <div className="bg-logo-green/10 border border-logo-green rounded-lg p-6 mb-6">
            <div className="flex items-start gap-3 text-left">
              <div className="text-2xl mt-1">⏱️</div>
              <div>
                <p className="font-semibold text-charcoal mb-2">
                  Timeline
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Background checks typically take 3-7 business days</li>
                  <li>• You may receive an email from our screening partner</li>
                  <li>• Once complete, we'll notify you immediately</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-amber-50 border border-amber-300 rounded-lg p-6 mb-6">
            <div className="flex items-start gap-3 text-left">
              <div className="text-2xl mt-1">📝</div>
              <div>
                <p className="font-semibold text-amber-800 mb-2">
                  What we check
                </p>
                <ul className="text-sm text-amber-700 space-y-1">
                  <li>• Driver's license validity</li>
                  <li>• Criminal record check</li>
                  <li>• Driving record</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm text-gray-600">
              <strong>Almost there!</strong> This is the final step before you can start delivering with Valley Eats.
            </p>
          </div>
        </div>
      </div>
    </WizardContainer>
  );
};

export default BackgroundCheck;
